import { render, staticRenderFns } from "./CarrierDimensions.vue?vue&type=template&id=13d4f2b0&scoped=true"
import script from "./CarrierDimensions.vue?vue&type=script&lang=js"
export * from "./CarrierDimensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d4f2b0",
  null
  
)

export default component.exports